export const GET_APP_STATUS_FROM_STATE = Symbol('appStatus/GET_FROM_STATE')
export const CLEAR_NEED_ACCEPT_OFFER = Symbol('appStatus/CLEAR_NEED_ACCEPT_OFFER')

/** Версии приложения, см. ниже */
const majorVersion = 1;
const minorVersion = 1;
const patch = 37;

/**
 * Версия приложения, формат основан на semver.
 * Первая цифра - мажорная, потом две - минорная, потом две - патч.
 */
export const APP_VERSION = String(majorVersion * 10000 + minorVersion * 100 + patch);